import styled from 'styled-components'

interface BtnContatoProps {
  isActive: boolean;
}

export const Container = styled.div`
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;

  margin: 0 auto;
  margin-bottom: 15px;
  max-width: 500px;
  padding: 0 5px;

  @media screen and (max-width: 766px) {
    max-width: 420px;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  height: 100%;
  width: 100%;

  h3 {
    font-size: 20px;
    font-weight: normal;
    margin-bottom: 16px;
    text-align: center;
    color: ${props => props.theme.colors.greyDarker};
  }

  p {
    margin: 0 15px;
  }

  ul {
    margin: 10px 25px 15px;
    font-size: 14px;

    li {
      margin-bottom: 5px;
      list-style: circle;
    }
  }

  span {
    font-weight: 550;
    padding: 0 15px;
    width: 100%;
  }

  small {
    padding: 0 15px;
    width: 100%;
    color: ${props => props.theme.colors.grey03};
  }
`

export const RadioButton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;

  width: 100%;
  padding: 10px 12px 5px;
  transition: .2s;

  > label {
    transform: translateY(-12px);
    font-size: 14px;
  }

  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
    width: 100%;
    margin: 0 auto;
  }

  @media screen and (max-width: 700px) {
    padding: 10px 5px 5px;

    > div {
      justify-content: space-evenly;
    }
  }
`

export const BtnContato = styled.button<BtnContatoProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 4px;
  border: 2px solid ${props => props.isActive? props.theme.colors.mainColor : '#DEE3E1'};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05), 0px 6px 12px rgba(61, 69, 67, 0.05);
  background-color: #FFF ;

  padding: 8px 60px;

  font-size: 16px;
  color: ${props => props.isActive? props.theme.colors.mainColor : '#8E9191'};

  &:disabled {
    cursor: not-allowed;
    background-color: #bababa;
    color: ${({ theme }) => theme.colors.whiteDarker};
    border: 1px solid #EAEAEA;
  }

  &:focus {
    text-decoration: underline;
  }

`

export const Line = styled.div`
  width: 85%;
  height: 1px;
  margin: 15px auto;
  background-color: ${props => props.theme.colors.grey04};
`
